import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from 'app/core/auth.service';
import { environment } from '../../../clients/dianet/src/environments/environment';

declare var $: any;

@Injectable()
export class CustomPushNotify {

    constructor(
        private http: HttpClient,
        private authService: AuthService,
    ) { }

    async pushMessage(title: string, text: string, specificUseruid?: string) {

        let getUrl = ''

        const token = await this.authService.getUserAuthToken()

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            })
        };

        if (specificUseruid) {
            getUrl = environment.functionsUrl + '/pushNotification/push-to-user';
        } else {
            getUrl = environment.functionsUrl + '/pushNotification/push-to-all';
        }

        console.log({
            text: text,
            title: title,
            uid: specificUseruid
        })
        this.http.post(getUrl, {
            text: text,
            title: title,
            uid: specificUseruid
        }, httpOptions).toPromise().catch(error => {
            // this should be fixed
            // Throwing error here
            console.log(error.message)
        })
    }
}
